module.exports = __webpack_public_path__ + "images/165_1024.jpg";